import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

import { Service } from '@/types/service';
import { Checkbox } from './Checkbox';

export type Props = {
  values: number[];
  list: Service[];
  onChange: (serviceId: number, checked: boolean) => void;
  error?: boolean;
};

export const Checkboxes: React.FC<Props> = ({
  values,
  list,
  onChange,
  error,
}) => {
  return (
    <Wrapper>
      {list.map((item, i) => (
        <label
          data-test={`service-${i}`}
          htmlFor={`service-${item.id}`}
          key={item.id}
          className={classNames(
            'service-item',
            error && 'error',
            values.includes(item.id) && 'active',
          )}
        >
          <Checkbox
            id={`service-${item.id}`}
            checked={values.includes(item.id)}
            onChange={(checked) => onChange(item.id, checked)}
          />
          <div className="service-content">
            <div className="name">{item.name}</div>
            <div className="subtitle">{item.subtitle}</div>
          </div>
        </label>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13.3px;
  padding: 0 3px;
  margin-bottom: 10px;

  .service-item {
    cursor: pointer;
    padding: 15.2px;
    padding-left: 22.2px;
    border: 1px solid transparent;
    background-color: white;
    box-shadow:
      0 1px 3px 0 #d4d4d5,
      0 0 0 1px #d4d4d5;
    border-radius: 5px;

    display: flex;
    gap: 17.5px;

    align-items: center;

    &.active {
      background-color: #f1f9ff;
    }

    &.error {
      background-color: #fff6f6;
      border-color: #e0b4b4;
      color: #9f3a38;
    }

    &:hover {
      box-shadow: 0 0 1px #96c8da;
    }
  }

  .service-content {
    display: flex;
    flex-direction: column;
    gap: 3.8px;
    padding-top: 2.3px;

    .name {
      font-size: 15.2px;
      font-weight: 700;
      line-height: 19.5429px;
    }

    .subtitle {
      font-size: 13px;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.4);
    }
  }
`;
